module.exports = __webpack_public_path__ + "static/media/ThunderMoon11n.546e4e5e.png";